import type { StateCreator } from 'zustand'

import { type InsuracesState, INITIAL_STATE } from './types'

const createInsurancesSlice: StateCreator<InsuracesState, [], [], InsuracesState> = (set) => ({
  insurances: INITIAL_STATE,
  setInsurancesObject: (insurances) => set(() => ({ insurances })),
  resetInsurance: () => set(() => ({ insurances: INITIAL_STATE })),
})

export default createInsurancesSlice
